<mat-card appearance="outlined">
    <mat-card-content class="request-content">
        <mat-expansion-panel hideToggle class="mat-elevation-z0">
            <mat-expansion-panel-header>
                <mat-panel-title>{{ request.type }} Request</mat-panel-title>
                <mat-panel-description>
                    @if (!request.isDisabled) {
                        <span>{{ request.progress }}%</span>
                        <span class="complete-text">&nbsp;Complete</span>
                    }
                    @if (request.isDisabled) {
                        <span>Cancelled</span>
                    }
                </mat-panel-description>
            </mat-expansion-panel-header>
            <mat-progress-bar
                mode="determinate"
                [value]="request.progress"
            ></mat-progress-bar>
            <div class="request">
                <div class="left-request-panel">
                    <mat-list>
                        <mat-list-item>
                            <span matListItemTitle>Status</span>
                            <span matListItemLine>{{ request.status }}</span>
                        </mat-list-item>
                        <mat-list-item>
                            <span matListItemTitle>Type</span>
                            <span matListItemLine>{{ request.type }}</span>
                        </mat-list-item>
                        <mat-list-item>
                            <span matListItemTitle>Bill Version</span>
                            <span matListItemLine>
                                {{
                                    request.billVersion.actionDate
                                        | date: "M/dd/YYYY"
                                }}
                                - {{ request.billVersion.subject }}
                            </span>
                        </mat-list-item>
                        <mat-list-item>
                            <span matListItemTitle>Priority</span>
                            <span matListItemLine>{{ request.priority }}</span>
                        </mat-list-item>
                        <mat-list-item>
                            <span matListItemTitle>Final Due Date</span>
                            <span matListItemLine>{{
                                request.due | date: "M/dd/YYYY"
                            }}</span>
                        </mat-list-item>
                    </mat-list>
                </div>
                <div class="right-request-panel">
                    <h4>Coordinators</h4>
                    <mat-list>
                        <mat-list-item
                            *ngFor="let coordinator of request.coordinators"
                        >
                            <mat-icon matListItemIcon>person</mat-icon>
                            <span matListItemTitle>{{
                                coordinator.user.name
                            }}</span>
                        </mat-list-item>
                    </mat-list>
                </div>
            </div>
        </mat-expansion-panel>
        <!-- TODO: Show Assignments (modal/expansion?) -->
        <!-- TODO: Show Assignments (modal/expansion?) -->
        <a
            [routerLink]="['/requests', request.id]"
            class="open-analysis-link"
            aria-label="view request"
            mat-icon-button
            color="primary"
            matTooltip="View Request"
        >
            <mat-icon>chevron_right</mat-icon>
        </a>
    </mat-card-content>
</mat-card>
